<template>
<div class="z-footer bg-color">
	<div v-for="(item,index) in menus" :class="[active==index?'z-footer-active':'normal']">
		<router-link :to="item.href">
			<img :src="active==index?item.iconActive:item.icon">
			<label v-text="item.label"></label>
		</router-link>
	</div>
</div>
</template>
<script>
export default {
	name: 'footerPage',
	props: {
		active: [Number,String]
	},
	data(){
		return {
			menus:[
				{
					label:this.$t('首页'),
					href:'/',
					icon:require('../assets/bottom_menu/index.png'),
					iconActive:require('../assets/bottom_menu/index-active.png')
				},
                {
					label:this.$t('行情'),
					href:'/market',
					icon:require('../assets/bottom_menu/hq.png'),
					iconActive:require('../assets/bottom_menu/hq-active.png')
				},
                {
                	label:this.$t('交易记录'),
                	href:'/sort', // /sort资讯
                	icon:require('../assets/bottom_menu/notice.png'),
                	iconActive:require('../assets/bottom_menu/notice-active.png')
                },
                {
					label:this.$t('我的'),
					href:'/my',
					icon:require('../assets/bottom_menu/my.png'),
					iconActive:require('../assets/bottom_menu/my-active.png')
				},
			]
		}
	},
  methods:{

  },
  created() {
    this.$nextTick(() => {

      let z_footer = document.getElementsByClassName('z-footer')[0]
      // console.log(z_footer);

      z_footer.addEventListener('touchmove', (e) => {
       if (e._isScroller) return;
         e.preventDefault()
       }, {
         passive: false
       })

    })
  }

}
</script>
<style scoped>
.z-footer {
	margin: 0;
    padding: 5px 0px 0px 0px;
    position: fixed;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    list-style: none;
    background: #1e1f23;
    font-size: 16px;
    padding-bottom: env(safe-area-inset-bottom);
	display: -webkit-flex;
	display: flex;
	justify-content:space-around;
	align-items:center;
	z-index: 999;
  border-top: 1px solid #ddd;
  box-shadow: 0 -10px 20px #1e1f23;

}
.z-footer>div a{
	display: -webkit-flex;
	display: flex;
	flex-direction: column;
	align-items:center;
	color:#fff;
	text-decoration:none;
}
.z-footer img{
	width: 19px;
}
.normal label{
  color: #fff;
}
.z-footer-active label{
	color: #E2B96F;
}
</style>



// WEBPACK FOOTER //
// src/components/ButtomMenu.vue